import React from 'react'
import { Link } from 'react-router-dom';
import '../layouts/PackingInvoiceNavbar.scss';
import customer from '../assets/images/customer.svg';
import projectMaster from '../assets/images/projectMaster.svg';
import companyMaster from '../assets/images/companyMaster.svg';
import distributorMaster from '../assets/images/distributorMaster.svg';
import productMaster from '../assets/images/productMaster.svg';

const PackingInvoiceNavbar = () => {
    return (
        <div className='container-fluid packing-invoice-nav-bar'>
            <div className='row ml-4 mr-4 mt-5'>
                <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                                    <div className='d-flex'>
                                        <div className='card card1 m-3'>
                                            <Link to="/packing-list">
                                                <div className='card-body'>
                                                    <img src={customer}></img>
                                                    <h5 className='mt-3'>Packing list</h5>
                                                </div>
                                                <div className='card-footer'>
                                                    <h6>Total packing lists : <span>1240</span></h6>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className='card card2 m-3'>
                                            <Link to="/invoice-list">

                                                <div className='card-body'>
                                                    <img src={projectMaster}></img>
                                                    <h5 className='mt-3'>Invoice</h5>
                                                </div>
                                                <div className='card-footer'>
                                                    <h6>Total invoices : <span>1240</span></h6>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className='card card3 m-3'>
                                            <Link to="/delivery-note-list">
                                                <div className='card-body'>
                                                    <img src={companyMaster}></img>
                                                    <h5 className='mt-3'>Delivery note</h5>
                                                </div>
                                                <div className='card-footer'>
                                                    <h6>Delivery note : <span>1240</span></h6>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PackingInvoiceNavbar